


























































































































helpers = require('../../../helpers.coffee')

view_model =
  components:
    triggerStages: require './trigger_stages.vue'
    dealLost: require './deal_lost.vue'
    propertiesMatching: require './properties_matching.vue'
    stagesMatching: require './stages_matching.vue'

  data: ->
    current_user: Session.current_user
    pipedrive_setting: if Session.current_user.pipedrive_setting.id? then Session.current_user.pipedrive_setting else new PipedriveSetting()
    add_contacts_to_pipedrive: Session.current_user.pipedrive_setting.add_contacts_to_pipedrive
    pipedrive_api_key: Session.current_user.pipedrive_api_key || ''
    url_pipedrive: 'https://api.pipedrive.com/v1/'
    api_fields: []
    stage_lost: false
    integration_stages: []
    matching: []
    matching_stages: [],
    update_stages_all_users: false
    pipelines: []
    selected_pipeline: { stage_query: null }
    loading_api_key: false
    copy_settings: false
    user_pipe_setting: null
    users_options_pipedrive: []
    pipedrive_setting_copy: []

  methods:
    toggleMarkAddContatsToPipedrive: ->
      @add_contacts_to_pipedrive = !@add_contacts_to_pipedrive

    toggleCopySettings: ->
      @copy_settings = !@copy_settings

    loadUsersPipedrive: ->
      roles = [ User.ROLES['seller'], User.ROLES['sdr'], User.ROLES['manager'] ]
      company_id = Session?.current_company?.id
      new UsersResource().index(@loadUsersPipedriveSuccess, null, params: {q: {s: 'name asc', role_in: roles}, company_id: company_id})

    loadUsersPipedriveSuccess: (data) ->
      for user in data.users
        if user.pipedrive_api_key != null
          @pipedrive_setting_copy.push (user)
          @users_options_pipedrive.push ({ value: {user_id: user.id}, text: user.firstAndLastName() })
      @users_options_pipedrive.unshift(value: null, text: @$t('general.label.user'))

    copy: ->
      if @user_pipe_setting.user_id != null
        data = @pipedrive_setting_copy.filter (item) => item.id == @user_pipe_setting.user_id
        data_pipe = data[0].pipedrive_setting
        @add_contacts_to_pipedrive = data_pipe.add_contacts_to_pipedrive
        @pipedrive_setting.mark_as = data_pipe.mark_as
        @pipedrive_setting.triggers = data_pipe.triggers
        @pipedrive_setting.properties_matching = data_pipe.properties_matching
        @pipedrive_setting.metadata.pipeline_id = data_pipe.metadata.pipeline_id
        @selected_pipeline = data_pipe.metadata.pipeline_id
        @pipedrive_setting.stages_matching = data_pipe.stages_matching

    save: ->
      @$validator.validateAll({@pipedrive_api_key}).then (success) =>
        @updatePipedriveApiKey() if success

    updatePipedriveApiKey: ->
      for stage in @matching_stages
        if !stage.reev || !stage.integration
          return alertify.error(this.$t('integrations.feedback.requiredFunnelStageMap'))

      quant = { }

      for item in @matching_stages
        if item.integration != this.$t('integrations.label.ignore')
          quant[item.integration] = 0 if quant[item.integration] == undefined || quant[item.integration] == NaN
          quant[item.integration] += 1

        if quant[item.integration] > 1
          return alertify.error(this.$t('integrations.feedback.onlyIgnoreStage'))

      for property in @matching
        property.type = @api_fields.find((field) -> field.key == property.integration ).type

      metadata = @pipedrive_setting.metadata
      if @integration_stages.length > 0
        metadata['default_stage'] = @integration_stages[0].id

      Loader.on()
      params = {
        id: Session.current_user.id,
        @pipedrive_api_key,
        @update_stages_all_users,
        @user_to_update_stages,
        pipedrive_setting_attributes: {
          id: @pipedrive_setting.id,
          stage_id: @pipedrive_setting.stage_id,
          add_contacts_to_pipedrive: @add_contacts_to_pipedrive,
          triggers: @pipedrive_setting.triggers,
          metadata: metadata,
          properties_matching: @matching,
          stages_matching: @matching_stages,
          mark_as: @pipedrive_setting.mark_as
        }
      }
      new UsersResource().update(@updatePipedriveApiKeySuccess, @pipedriveErrors, params)

    removePipedriveApiKey: ->
      @pipedrive_api_key = null
      @matching = []
      @matching_stages = []
      @integration_stages = []
      @pipedrive_setting.stages_matching = []
      @pipelines = []
      Loader.on()
      params = {
        id: Session.current_user.id,
        @pipedrive_api_key,
        pipedrive_setting_attributes: {
          id: @pipedrive_setting.id,
          _destroy: true
        }
      }
      new UsersResource().update(@updatePipedriveApiKeySuccess, @pipedriveErrors, params)

    updatePipedriveApiKeySuccess: (data, response) ->
      Loader.off()
      message_action = if data.user.pipedrive_api_key then this.$t('general.actions.connectedTo') else this.$t('general.actions.disconnectedTo')
      alertify.success this.$t('integrations.feedback.pipedriveSuccess')
      Session.signIn(response.body.user)
      @current_user = Session.current_user
      @pipedrive_api_key = data.user.pipedrive_api_key
      @pipedrive_setting.stage_id = data.user.pipedrive_setting.stage_id
      intercom_event_name = if data.user.pipedrive_api_key then this.$t('integrations.feedback.connectedToPipedrive') else this.$t('integrations.feedback.disconnectedToPipedrive')
      IntercomCtrl.trackEvent(intercom_event_name)

    pipedriveErrors: (response, options={}) ->
      @handleApiErrors(response, options)
      if(response.body.pipedrive_setting)
        for error in response.body.pipedrive_setting
          @errors.add(error, this.$t('general.feedback.invalid'))

    updateWebhookSuccess: (data, response) ->
      Loader.off()
      Session.signIn(response.body.user)
      @current_user = Session.current_user
      alertify.success this.$t('general.feedback.settingSaved')
      @closeForm()

    setStagesPipedrive: (data) ->
      @pipedrive_setting.triggers = data
      @update_stage_lost(data.stages)

    setMarkAs: (data) ->
      @pipedrive_setting.mark_as = data

    update_stage_lost: (stages = {}) ->
      lost_stage = stages.filter (item) -> item == 'lost'
      if lost_stage.length != 0
        return this.stage_lost = true
      return this.stage_lost = false

    matchingUpdated: (data) ->
      @matching = data.filter (field) -> 
        !(field.reev == undefined || field.reev == '')

    matchingStagesUpdated: (data) ->
      @matching_stages = data

    updateUsers: (data) ->
      @update_stages_all_users = data.update_all_users
      @user_to_update_stages = data.user_id

    getTypeField: (type) ->
      return 'enum' if type == 'enum'
      return 'tel' if type == 'phone'
      return 'date' if type == 'date'
      return 'number' if type == 'double'
      return 'number' if type == 'int'
      'text'

    loadPipedriveFields: ->
      return if @pipedrive_api_key == ''
      @loadFields()
      @loadPipelines()

    loadFields: ->
      if !Array.isArray @pipedrive_setting.properties_matching
        @pipedrive_setting.properties_matching = new PipedriveSetting().properties_matching
      @pipedrive_setting.properties_matching = [] if @pipedrive_setting.properties_matching == {}
      @loadPersonFields()
      @loadDealFields()

    loadPersonFields: ->
      self = @
      @$http.get(@url_pipedrive + 'personFields?api_token=' + @pipedrive_api_key).then ((personResponse) =>
        fields = personResponse.body.data.filter (field) -> field.bulk_edit_allowed and field.key != 'name' and field.key != 'email' and field.key != 'visible_to' and field.key != 'owner_id' and field.key != 'org_id'
        @api_fields = @api_fields.concat fields.map (field) -> { origin: 'person', type: self.getTypeField(field.field_type), key: field.key, name: field.name }
      ), ((personResponse) =>
      )

    loadDealFields: ->
      self = @
      @$http.get(@url_pipedrive + 'dealFields?api_token=' + @pipedrive_api_key).then ((dealResponse) =>
        fields = dealResponse.body.data.filter (field) -> field.bulk_edit_allowed and field.key != 'title' and field.key != 'org_id' and field.key != 'status' and field.key != 'stage_id' and ['user', 'people', 'stage'].indexOf(field.field_type) == -1
        @api_fields = @api_fields.concat fields.map (field) -> { origin: 'deal', type: self.getTypeField(field.field_type), key: field.key, name: field.name }
      ), ((dealResponse) =>
      )

    loadStages: (pipeline_id = @pipedrive_setting.metadata.pipeline_id) ->
      return @loadPipelines() if !pipeline_id
      @$http.get(@url_pipedrive + 'stages?pipeline_id=' + pipeline_id + '&api_token=' + @pipedrive_api_key).then ((response) =>
        @integration_stages = response.body.data.map (stage) -> { name: stage.name, id: stage.id }
      ), ((response) =>
      )

    loadPipelines: ->
      @$http.get(@url_pipedrive + 'pipelines?api_token=' + @pipedrive_api_key).then ((response) =>
        @pipelines = response.body.data.map (pipeline) -> { value: { stage_query: pipeline.id }, text: pipeline.name }
        @pipelines.unshift { value: { stage_query: null }, text: 'Selecione um funil' }
        for pipeline in response.body.data
          if @pipedrive_setting.metadata.pipeline_id
            if pipeline.id == @pipedrive_setting.metadata.pipeline_id
              @pipedrive_setting.metadata.pipeline_id = pipeline.id
              return @loadStages()
          else
            if pipeline.url_title == 'default'
              @pipedrive_setting.metadata.pipeline_id = pipeline.id
              return @loadStages()

        @pipedrive_setting.metadata.pipeline_id = response.body.data[0].id
        return @loadStages()

      ), ((response) =>
      )

    loadByNewPipeline: (data) ->
      @pipedrive_setting.metadata.pipeline_id = data.pipeline.stage_query
      @pipedrive_setting.stages_matching = []
      @loadStages(data.pipeline.stage_query)

    closeForm: ->
      @$router.push path: '/configuracoes/integracoes'

    validate_api_key: ->
      @loading_api_key = true
      @$http.get(@url_pipedrive + 'pipelines?api_token=' + @pipedrive_api_key).then ((response) =>
        @errors.clear()
        @loading_api_key = false
        @loadPipedriveFields()
      ), ((response) =>
        @loading_api_key = false
        @errors.add('pipedrive_api_key', this.$t('integrations.feedback.invalidApiKey'))
      )

  computed:
    show_configuration_by_pipeline_name: ->
      @pipedrive_setting?.id && @pipedrive_setting?.metadata?.pipeline_name

    lost_checked: ->
      lost_stage = @pipedrive_setting.triggers.stages.filter (item) -> item == 'lost'
      if lost_stage.length != 0
        return true
      return false

  watch:
    pipedrive_api_key: ->
      return if @loading_api_key
      @validate_api_key()

  mounted: ->
    Tooltip.initialize()
    @loadPipedriveFields()
    @loadUsersPipedrive()
    @selected_pipeline = {stage_query: @pipedrive_setting?.metadata.pipeline_id}
    pipedrive_setting: ->
      @copy()

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/integrations/pipedrive.vue